module.exports = __webpack_public_path__ + "img/login_icon2.405a17ee.png";